import Dashboard from "../../../../assets/Dashboard.jsx";
import Organizer from "../../../../assets/Organizer.jsx";
import ReviewDoc from "../../../../assets/ReviewDoc.jsx";
import PrepareTax from "../../../../assets/PrepareTax.jsx";
import ReviewTax from "../../../../assets/ReviewTax.jsx";
import FollowUp from "../../../../assets/FollowUp.jsx";
import ReturnToGov from "../../../../assets/ReturnToGov.jsx";
import Communication from "../../../../assets/Communication.jsx";
import TeamConnect from "../../../../assets/TeamConnect.jsx";
import BusinessTask from "../../../../assets/BusinessTask.jsx";
import Setting from "../../../../assets/Setting.jsx";
import Clients from "../../../../assets/Clients.jsx";
import Reports from "../../../../assets/Reports.jsx";
import Disc from "../../../../assets/Disc.jsx";

const rolesData = {
  Dashboard: {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/employee_dashboard",
    activeUrl: ["/employee_dashboard"],
  },
  "Organizer Manage": {
    title: "Organizers",
    icon: <Organizer />,
    url: "/organizers",
    activeUrl: ["/organizers"],
  },
  "Verify Doc": {
    title: "Verify Doc",
    icon: <ReviewDoc />,
    url: "/verify_doc",
    activeUrl: ["/verify_doc"],
  },
  "Prepare Tax": {
    title: "Prepare Tax",
    icon: <PrepareTax />,
    url: "/prepare_tax",
    activeUrl: ["/prepare_tax"],
  },
  "Review Tax": {
    title: "Review Tax",
    icon: <ReviewTax />,
    url: "/review_tax",
    activeUrl: ["/review_tax"],
  },
  "Follow Up": {
    title: "Follow Up",
    icon: <FollowUp />,
    url: "/follow_up",
    activeUrl: ["/follow_up"],
  },
  "E-file": {
    title: "E-file",
    icon: <ReturnToGov />,
    url: "/e_file",
    activeUrl: ["/e_file"],
  },
  // Communication: {
  //   title: "Communication",
  //   icon: <Communication />,
  //   url: "/communication",
  //   activeUrl: ["/communication"],
  // },
  Clients: {
    title: "Clients",
    icon: <Clients />,
    url: "/clients",
    activeUrl: ["/clients", "/client"],
  },
  // "Team Connect": {
  //   title: "Team Connect",
  //   icon: <TeamConnect />,
  //   url: "/team_connect",
  //   activeUrl: ["/team_connect"],
  // },
  Task: {
    title: "Task",
    icon: <BusinessTask />,
    url: "/task",
    activeUrl: ["/task"],
  },
  Reports: {
    title: "Reports",
    icon: <Reports />,
    activeUrl: ["/report/organizer"],
    children: [
      {
        title: "Organizer",
        icon: <Disc />,
        url: "/report/organizer",
        activeUrl: ["/report/organizer"],
      },
      {
        title: "Active Job",
        icon: <Disc />,
        url: "/report/active_job",
        activeUrl: ["/report/active_job"],
      },
      {
        title: "Complete Job",
        icon: <Disc />,
        url: "/report/complete_job",
        activeUrl: ["/report/complete_job"],
      },
      {
        title: "Overdue Job",
        icon: <Disc />,
        url: "/report/overdue_task",
        activeUrl: ["/report/overdue_task"],
      },
      {
        title: "Referral Report",
        icon: <Disc />,
        url: "/report/referral",
        activeUrl: ["/report/referral"],
      },
      {
        title: "Payment",
        icon: <Disc />,
        url: "/report/payment",
        activeUrl: ["/report/payment"],
      },
    ],
  },
  Settings: {
    title: "Settings",
    icon: <Setting />,
    url: "/settings",
    activeUrl: ["/settings"],
  },
};

export default rolesData;
